import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { BaseApi } from "../../laas/base-api.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { environment as ENV } from "../../../environments/environment";
import { environment } from "../../../environments/environment.ubi";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { saveAs } from "file-saver/dist/FileSaver";
import FileSaver from "file-saver";
import { AdminService } from "../../admin/admin.service";
import { DatePipe } from "@angular/common";
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormArray,
  UntypedFormBuilder,
  Validators,
} from "@angular/forms";
import { AddCustomerService } from "../../admin/add-customer.service";
import { FreshAuthService } from "../fresh-auth.services";
import { AdvancedFilterService } from "app/core/advanced-filter/advanced-filter.service";
import { log } from "console";
import *  as constants from "../../../app/constant";

@Component({
  selector: 'wl-view-etb',
  providers: [AddCustomerService, AdminService],
  templateUrl: './view-etb.component.html',
  styleUrls: ['./view-etb.component.scss'],
})
export class ViewEtbComponent implements OnInit {
  downloadForms: any[];
  noUserFound: string;
  loading: boolean;
  search = new UntypedFormControl();
  searchHolder: string;
  downloadDocModalRef: NgbModalRef;
  pageId = 1;
  showSelectedDate: boolean;
  selectedDate: any;
  selectedOption: string;
  page: number = 1;
  offset: number = 0;
  totalCount: any;
  totalPage: number = 1;
  adminForm: UntypedFormGroup;
  iscredCount: any;
  showOrHide: boolean;
  roleId: number;
  @ViewChild('downloadModal') downloadModal: TemplateRef<any>;
  @ViewChild('date1') firstDate: ElementRef;
  public etbForm: UntypedFormGroup;
  kccNewUat: string = environment.kccNewUat;
  filterTableDate = new Date();
  formatFilterTableDate: any = new DatePipe('en-US').transform(this.filterTableDate, 'y-MM');
  allUsers: any = [];
  subheading1: string;
  subheading2: string;
  limit: string;
  maxDate: string;
  selectedStartDate: any;
  selectedEndDate: any;
  dateInMs: number;
  endDateInMs: number;
  showEtbDataTable: boolean = true;
  filter: string = ""
  currentUser: any;
  showModal: boolean;
  checkBoxObj: any;
  checkBoxList: any;
  allUsersNew: any;
  showDownloadModal: boolean;
  showChecksColumn: boolean;
  showDownloadUploadColumn: boolean;
  applicantId: any;
  wantAccWiseBreDownloaded: boolean;
  showSanctionedDocuments: boolean;
  showAccwiseBreCheckBox: boolean = false;
  showDownloadDocsModal: boolean;
  lienCheckBoxCode: string = 'cropLienCreated';
  lienCheckBoxInfo: string = 'Creation / noting of Banks lien (Hypothecation) on the Standing / Proposed Crop is done as per the extant guidelines, wherever online charge creation facility is available.';

  constructor(
    private baseapi: BaseApi,
    private api: BaseApi,
    private fb: UntypedFormBuilder,
    private _fb: UntypedFormBuilder,
    private snackbar: MatSnackBar,
    private modalService: NgbModal,
    private adminservice: AdminService,
    private activatedRoute: ActivatedRoute,
    private https: HttpClient,
    private customer: FreshAuthService,
    private freshAuthService: FreshAuthService,
    private advancedFilterService: AdvancedFilterService,
    private cdr: ChangeDetectorRef
  ) {

    this.iscredCount = ENV.creditScoreSetting.credCount;
    if (ENV.creditScoreSetting.credMenu == 'shfl') {
      this.showOrHide = false;
    } else {
      this.showOrHide = true;
    }
    this.searchHolder = 'Search Applicant by Name';
  }

  onSearchClick(event) {
    this.loading = true;
  }

  onSearch(value: string) {
    this.filter = value;
    if (this.isCoLogin()) {
      return this.applyFilter(this.filter, 0, 1, 1);
    }

    this.page = 1;
    this.pageId = 1;
    this.loading = true;

    this.customer.getEtbUsers(value, 1, 0, 10).subscribe(
      (res) => {
        this.loading = false;

        if (res && res.success) {
          if (res.result && res.result.resultData && res.result.resultData.length === 0) {
            this.noUserFound = 'Customer data not found';
          } else {
            this.noUserFound = null;
          }
          this.allUsers = res.result.resultData ? res.result.resultData : [];
          this.setCheckBoxesStatuses(this.allUsers);
          this.totalCount = res.result.count ? res.result.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
        } else {
          this.noUserFound = 'Customer data not found';
          this.allUsers = [];
          this.allUsersNew = [];
          this.totalCount = 0;
          this.totalPage = 0;
        }
      },
      (err) => {
        this.totalCount = 0;
        this.totalPage = Math.ceil(this.totalCount / 10);
        this.allUsersNew = [];
        this.loading = false;
        throw err;
      }
    );
  }

  ngOnInit() {
    this.roleId = +this.freshAuthService.getRoleId();
    if (this.isCoLogin()) {
      this.showEtbDataTable = false;
      this.showAccwiseBreCheckBox = true;
    }

    sessionStorage.removeItem('filterDateEtbStart');
    sessionStorage.removeItem('filterDateEtbEnd');
    this.maxDate = this.freshAuthService.getCurrentMonth();

    this.subheading1 = this.adminservice.getBranchName();
    this.subheading2 = this.adminservice.getSolID();

    !this.isCoLogin() && this.getData();

    if (sessionStorage.getItem('wEnlw3OeU3')) {
      this.getCheckBoxes();
    };

    this.showOrHideTableColumns();

  }


  setCheckBoxesStatuses(allUsers) {
    this.allUsersNew = allUsers.map((user, index) => {
      if (user && user.user_checklist_options) {
        const data = user.user_checklist_options;
        user.checkBoxList = [];

        for (let key in data) {
          if (data[key]) {
            const currentCheckBoxObj = this.checkBoxList.find(item => item.code === key);
            if (currentCheckBoxObj) {
              user.checkBoxList.push({
                ...currentCheckBoxObj,
                checked: false
              });
            }
          }
        }
        user.checkBoxesList = user.checkBoxList;
        // this.checkAndDisableAllCheckboxes(index)

      } else {
        user.checkBoxesList = this.checkBoxList.map((item) => ({
          ...item,
          checked: false
        }));
      }
      user.isAllChecked = this.isAllChecked(user.checkBoxesList);
      if (user.loanAccountNo) {
        user.loanAccountCreated = true;
      }
      console.log("loanAccountCreated", user.loanAccountCreated);
      
      return user;
    });

    this.allUsersNew.forEach((user, index) => {
      if (user.user_checklist_options) {
        this.checkAndDisableAllCheckboxes(index)
      }
    })

    console.log(this.allUsersNew);


  }

  isAllChecked(checkBoxesList): boolean {
    return checkBoxesList.every(item => item.checked);
  }

  toggleCheckbox(userIndex: number, checkboxIndex: number) {
    let user = this.allUsersNew[userIndex];
    user.checkBoxesList[checkboxIndex].checked = !user.checkBoxesList[checkboxIndex].checked;
    user.isAllChecked = this.isAllChecked(user.checkBoxesList);
  }

  submitCheckBoxes(user, i) {

    let check_box_list = [];
    user.checkBoxesList.forEach((obj) => {
      check_box_list.push(obj.code)
    })

    const payload = {
      applicantId: user.id,
      selectedOptions: check_box_list,
      adminId: sessionStorage.getItem('getuserId')
    }
    console.log(payload);

    this.freshAuthService.submitCheckboxes(payload).subscribe((resp) => {
      console.log(resp);
      if (resp && resp.status) {
        this.allUsersNew[i].isCheckBoxesSubmitted = true;
      }
    }, (err) => {
      this.snackbar.open("Failed to submit details", "OK", { duration: 3000 })
    })
  }

  checkAndDisableAllCheckboxes(userIndex: number) {

    if (this.allUsersNew) {
      let user = this.allUsersNew[userIndex];
      user.checkBoxesList.forEach(item => {
        item.checked = true;
        item.disabled = true;
      });
      user.isCheckBoxesSubmitted = true;
      user.isAllChecked = this.isAllChecked(user.checkBoxesList);
    }
  }


  getCheckBoxes() {
    this.freshAuthService.fetchUsersChecklistOptions().subscribe((resp) => {
      console.log(resp)
      if (resp && resp.message.toLowerCase() == "success") {
        let data = resp.data;
        this.checkBoxList = [];
        for (let key in data) {
          if (data[key].enabled) {
            this.checkBoxList.push({ code: key, ...data[key] })
          }
        }
        console.log(this.checkBoxList)
      }
    }, (err) => {
      this.snackbar.open("Failed to fetch checkbox list.", "OK")
    })
  }

  uploadPopup(user) {
    this.currentUser = user;
    this.showModal = true;
  }

  handleClose() {
    this.showModal = false;
  }

  handleCloseDownload() {
    this.showDownloadModal = false;
  }

  downloadPopup(user) {
    this.currentUser = user;
    this.showDownloadModal = true;
  }

  filesUploaded(event) {

  }

  createLoanAccount(user, i) {
    console.log(user);

    this.loading = true;
    const applicantId = user.id;
    this.baseapi.createLoan(user.id).subscribe((resp) => {
      console.log(resp);
      this.loading = false;
      if (resp && resp.success) {
        user.loanAccountNumber = resp.loanAccountNumber;

        this.allUsersNew[i].loanAccountCreated = true;

        this.snackbar.open('Loan Created Successfully', 'OK', { duration: 3000 });
      } else {
        this.snackbar.open(`resp.message`, 'OK', { duration: 3000 });
      }
    }, (err) => {
      this.loading = false;
      this.snackbar.open("Failed to create loan account", "OK", { duration: 5000 })
    });
  }

  getData() {
    this.loading = true;
    const admin_id = sessionStorage.getItem('wl-admin-id');
    const branch_code = sessionStorage.getItem('branch_code');
    const ro_code = sessionStorage.getItem('ro_code');
    const zonal_code = sessionStorage.getItem('zonal_code');

    this.freshAuthService
      .loanSanctionedEtb(
        admin_id,
        branch_code,
        ro_code,
        zonal_code,
        0, //offset
        10, //limit
        1, //roleid
        '', //filter
        'loan_sanctioned_etb'
      )
      .subscribe(
        (res) => {
          this.loading = false;
          console.log(res, 'abc');
          this.allUsers = res.resultData ? res.resultData : [];
          this.setCheckBoxesStatuses(this.allUsers);
          console.log("this is 2")
          // debugger
          this.totalCount = res && res.count ? res.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          console.log('this.totalPage ' + this.totalPage);
        },
        (err) => {
          this.loading = false;
          this.allUsersNew = []
          throw err;
        }
      );
  }

  getAllUsersPage(input, roleId, offset, limit, pageId) {
    if (this.isCoLogin()) {
      return this.applyFilter(input, offset, pageId, pageId);
    }

    const admin_id = sessionStorage.getItem('wl-admin-id');
    const branch_code = sessionStorage.getItem('branch_code');
    const ro_code = sessionStorage.getItem('ro_code');
    const zonal_code = sessionStorage.getItem('zonal_code');

    console.log(pageId);
    this.pageId = pageId;
    this.loading = true;

    console.log('before page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);
    this.page = pageId;
    this.offset = offset;
    this.limit = limit;

    console.log('after page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);

    this.freshAuthService
      .loanSanctionedEtb(
        admin_id,
        branch_code,
        ro_code,
        zonal_code,
        offset,
        limit,
        1,
        input,
        'loan_sanctioned_etb'
      )
      .subscribe(
        (res) => {
          this.loading = false;
          console.log('result ' + JSON.stringify(res));
          this.allUsers = res.resultData ? res.resultData : '';
          this.setCheckBoxesStatuses(this.allUsers);
          this.totalCount = res && res.count ? res.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          console.log('this.totalPage ' + this.totalPage);
          // this.custId = res.result.custId;
          // console.log("custId " +  res.result.custId);
        },
        (err) => {
          this.allUsersNew = [];
          this.loading = false;
          //this.allUsers = Observable[''];
          throw err;
        }
      );
  }

  // getApplicationStatus(user) {
  //   if (user == 'satsureReportGenerated') {
  //     return 'Cropping pattern selection pending';
  //   } else if (user == 'satsureReportFailed') {
  //     return 'Satsure report failed and pending';
  //   } else if (user == 'LAND_RECORD') {
  //     return 'Cropping pattern selection pending';
  //   } else if (user == 'docsExecuted') {
  //     return 'E-signing of docs pending';
  //   } else if (user == 'docsExecutedRequest') {
  //     return 'E-signing of docs pending';
  //   } else if (user == 'loanDisbursed') {
  //     return 'Loan Disbursed';
  //   } else if (user == 'cropPatternSubmitted') {
  //     return 'Loan amount submission pending';
  //   } else if (user == 'cropPatternFailed') {
  //     return 'Cropping pattern submission failed';
  //   } else if (user == 'loanRefNoGenerated') {
  //     return 'Loan reference Number generated';
  //   } else if (user == 'loanAmountCalculated') {
  //     return 'Loan amount calculated, Submission pending';
  //   } else if (user == 'loanAmountCalculationFailed') {
  //     return 'Loan amount calculation failed';
  //   }
  // }

  getAppStatusMessage(appStatus) {
    if (this.showChecksColumn) {
      switch (appStatus) {
        case "loanRefNoGenerated":
          return "Land Verification Pending";
        case "satsureReportGenerated":
          return "Cropping Pattern Selection Pending";
        case "cropPatternSubmitted":
          return "Loan Sanction Pending";
        case "loanAmountCalculated":
          return "Loan Amount Sanctioned";
        case "loanDisbursed":
          return "Loan Disbursed";
        default:
          return "Unknown Status";
      }
    } else {
      switch (appStatus) {
        case "loanRefNoGenerated":
          return "Land Verification Pending";
        case "satsureReportGenerated":
          return "Cropping Pattern Selection Pending";
        case "cropPatternSubmitted":
          return "Loan Sanction Pending";
        case "loanAmountCalculated":
        case "docsExecutedRequest":
          return "Digital E-Sign Pending";
        case "docsExecuted":
          return "Loan Creation Pending";
        case "LAND_RECORD":
          return "Cropping Pattern Selection Pending";
        case "NESL":
          return "Loan Creation Pending";
        case "NESLREQUEST":
          return "Digital E-Sign Pending";
        case "loanDisbursed":
          return "Loan Disbursed";
        default:
          return "Unknown Status";
      }
    }

  }

  // getDocs(user) {
  //   const applicantId = user.id;
  //   this.downloadForms = [];
  //   this.loading = true;
  //   this.baseapi.getDocs(user.id).subscribe((resp) => {
  //     this.loading = false;
  //     if (resp.result) {
  //       this.downloadForms = resp.result.filter((form) => form.label != 'dm');
  //       this.downloadForms.forEach((form) => (form.isChecked = false));
  //       this.openModal4(user);
  //     }
  //     console.log(resp);
  //   });
  // }

  getDocs(user) {
    const applicantId = user.id;
    this.applicantId = user.id;
    this.downloadForms = [];
    this.loading = true;
    this.baseapi.getDocs(user.id).subscribe((resp) => {

      this.loading = false;
      if (resp.result && resp.result.length) {

        this.downloadForms = resp.result.filter((form) => form.label != 'dm');
        this.downloadForms.forEach((form) => (form.isChecked = false));
        let myArray = ["Loan Application Form", "Sanction Letter", "Digital Process Note",
          "Digitally Signed Document", "CIC Report", "Charge Khasra PDF 1", "Charge Khasra PDF 3"];

        const reorderedPdfArray = myArray.map(label => this.downloadForms.find(item => item.label === label));
        console.log(reorderedPdfArray)
        // const filteredArray = reorderedPdfArray.find(item=>item!==undefined)
        this.downloadForms = reorderedPdfArray.filter(Boolean);
        console.log(this.downloadForms)
        this.openModal4(user);
      }
      else {
        this.loading = false;
        this.snackbar.open("No data found.", "OK", { duration: 3000 })
      }
      console.log(resp);
    }, (err) => {
      this.loading = false;
      this.snackbar.open("Something went wrong", "OK", { duration: 3000 })
    });
  }

  changeAccWiseBre(event: any) {
    if (event.target.checked) {
      this.wantAccWiseBreDownloaded = true;
    } else {
      this.wantAccWiseBreDownloaded = false;
    }
  }

  downloadMyForms() {
    this.downloadForms.forEach((form) => {
      if (form.isChecked) {
        this.downloadLink(form);
      }
    });
    if (this.wantAccWiseBreDownloaded && this.isCoLogin()) {
      this.freshAuthService.downloadPdfAccWise(this.applicantId).subscribe(
        (resp) => {
        if (resp && resp.success) {
          if (resp.filePath) {

            try{
              const base64String = resp.filePath; // Your Base64 string here

              // Create a Blob from the Base64 string
              const byteCharacters = atob(base64String);
              const byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);
              const blob = new Blob([byteArray], { type: 'application/pdf' });
  
              // Create a URL for the Blob
              const blobUrl = URL.createObjectURL(blob);
  
              // Create a link and trigger download
              const link = document.createElement('a');
              link.href = blobUrl;
              link.download = 'KCC-bre-checklist.pdf';// Filename when downloaded
              document.body.appendChild(link);
              link.click();
  
              // Clean up: Remove the link and revoke the Blob URL
              document.body.removeChild(link);
              URL.revokeObjectURL(blobUrl);
            }catch(err){
              this.snackbar.open("Unable to download Accountwise BRE report","OK",{duration:3000})
            }
            

          }else{
            this.snackbar.open("Unable to download Accountwise BRE report","OK",{duration:3000})
          }
        } else {
          this.snackbar.open("Unable to download Accountwise BRE report","OK",{duration:3000})
        }
      },(err)=>{
        this.snackbar.open("Accountwise BRE report download failed","OK",{duration:3000})
      })
    }
  }

  //Modal which comes after clicking download doc button
  openModal4(user: any) {
    // this.downloadDocModalRef = this.modalService.open(this.downloadModal);
    this.showDownloadDocsModal = true;
    console.log(user);
  }
  //Modal which comes after clicking download doc button

  closeDownloadDocModal() {
    // this.downloadDocModalRef.close();
    this.showDownloadDocsModal = !this.showDownloadDocsModal;
  }

  // selectAllDownloadForms(event: any) {
  //   if (event.target.checked) {
  //     this.downloadForms.forEach((form) => (form.isChecked = true));
  //   } else {
  //     this.downloadForms.forEach((form) => (form.isChecked = false));
  //   }
  // }
  selectAllDownloadForms(event: any) {
    if (event.target.checked) {
      this.downloadForms.forEach((form) => (form.isChecked = true));
      if(this.isCoLogin()){
        this.handleCheckRef();
      }
      this.wantAccWiseBreDownloaded = true;
    } else {
      this.downloadForms.forEach((form) => (form.isChecked = false));
      if(this.isCoLogin()){
        this.handleCheckRef();
      }
      this.wantAccWiseBreDownloaded = false;
    }
  }

  private handleCheckRef() {
    // console.log(this.checkRef.nativeElement)
    // const checkbox = this.checkRef.nativeElement;
    const checkbox =document.getElementById('uniqueCheckboxDisbursed') as HTMLInputElement; 
    console.log(checkbox)
    checkbox.checked = !checkbox.checked;
  }
  // downloadMyForms() {
  //   this.downloadForms.forEach((form) => {
  //     if (form.isChecked) {
  //       this.downloadLink(form);
  //     }
  //   });
  // }

  downloadLink(form: any) {
    const { link, label } = form;
    const linkSource = link;
    const downloadLink = document.createElement('a');
    const fileName = `${label}.pdf`;
    console.log(label);

    downloadLink.href = `${this.kccNewUat}/static/${linkSource}`;
    console.log(linkSource);

    this.https.get(downloadLink.href, { responseType: 'arraybuffer' }).subscribe(
      (pdf) => {
        const blob = new Blob([pdf], { type: 'application/pdf' });
        const fileName = `${label}.pdf`;
        saveAs(blob, fileName);
      },
      (err) => {
        console.log('err->', err);
      }
    );
  }

  onDateRangeSelected(dateRange: any) {
    debugger
    this.pageId = 1;
    this.page = 1;
    this.offset = 0;
    this.selectedStartDate = dateRange.startDate;
    this.selectedEndDate = dateRange.endDate;
    console.log(dateRange.startDate, dateRange.endDate);
    let date = new Date(this.selectedStartDate);
    this.dateInMs = date.getTime();
    let strStart = this.dateInMs.toString();
    sessionStorage.setItem('filterDateEtbStart', strStart);
    let storeEnddate = new Date(this.selectedEndDate);
    this.endDateInMs = storeEnddate.getTime();
    let strEnd = this.endDateInMs.toString();
    sessionStorage.setItem('filterDateEtbEnd', strEnd);
    console.log('check date', this.endDateInMs);
    if (this.dateInMs <= this.endDateInMs) {
      let dateType = 'dateRange';
      this.showSelectedDate = true;
      let startDateConvert = dateRange.startDate.split('-').reverse().join('-');
      let endDateConvert = dateRange.endDate.split('-').reverse().join('-');
      this.selectedDate = startDateConvert + ' - ' + endDateConvert;
      this.customer
        .getEtbUsersFilterDate('', this.roleId, 0, 10, this.dateInMs, this.endDateInMs, dateType)
        .subscribe((res) => {
          console.log(res);
          if (res && res.result && res.result.resultData) {
            if (res && res.result && res.result.resultData) {
              this.allUsers = res.result.resultData ? res.result.resultData : '';
              this.setCheckBoxesStatuses(this.allUsers);
              this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
              this.totalPage = Math.ceil(this.totalCount / 10);
            }
          } else {
            // this.allUsers = this.getEmptyArray()
            this.allUsersNew = [];
            this.closeButtonClick();
            this.snackbar.open('No Applicants found. The Filter is not Applied', 'OK', {
              duration: 4000,
            });
          }
        });
    } else {
      this.snackbar.open('Please enter the valid date', 'OK', { duration: 4000 });
    }
  }

  // submitDates() {
  //   if(this.firstDate.nativeElement.value <= this.maxDate && this.firstDate.nativeElement.value >= '2022-01'  ){
  //   this.showSelectedDate = true;
  //   console.log(this.firstDate.nativeElement.value);
  //   let selected = this.firstDate.nativeElement.value;
  //   var months = [
  //     "January",
  //     "February",
  //     "March",
  //     "April",
  //     "May",
  //     "June",
  //     "July",
  //     "August",
  //     "September",
  //     "October",
  //     "November",
  //     "December",
  //   ];
  //   var another = months[+selected.split("-")[1] - 1];
  //   this.selectedDate = another + ", " + selected.split("-")[0];
  //   let filterDate = this.firstDate.nativeElement.value + "-01";
  //   sessionStorage.setItem("filterDateEtb", filterDate);
  //   let date = new Date(filterDate);
  //   let dateInMs = date.getTime();

  //   this.customer
  //     .getEtbUsersFilterDate("", this.roleId, 0, 10, dateInMs)
  //     .subscribe((res) => {
  //       console.log(res);
  //       if (res && res.result && res.result.resultData) {
  //         if (res && res.result && res.result.resultData) {
  //           this.allUsers = res.result.resultData ? res.result.resultData : "";
  //           this.totalCount =
  //             res && res.result && res.result.count ? res.result.count : 0;
  //           this.totalPage = Math.ceil(this.totalCount / 10);
  //         }
  //       } else {
  //         // this.allUsers = this.getEmptyArray()
  //         this.closeButtonClick();
  //         this.snackbar.open(
  //           "No Applicants found. The Filter is not Applied",
  //           "OK",
  //           { duration: 4000 }
  //         );
  //       }
  //     });
  //   }else{
  //     this.snackbar.open("Please enter the valid date",'OK', {duration:4000})
  //   }
  // }

  closeButtonClick() {
    this.selectedDate = '';
    this.showSelectedDate = false;
    sessionStorage.removeItem('filterDateEtbStart');
    sessionStorage.removeItem('filterDateEtbEnd');
    sessionStorage.removeItem('filterDateSanction');
    this.adminservice.reloadComponent(this.activatedRoute.snapshot['_routerState'].url);
  }

  isCoLogin() {
    if (this.roleId === 1) {
      return true;
    }
    return false;
  }

  async applyFilter(filter: string = '', offset: number = 0, pageId: number = 1, page: number = 1) {
    this.pageId = pageId;
    this.page = page;
    this.offset = offset;
    this.loading = true;
    this.showEtbDataTable = true;
    const formData = this.advancedFilterService.getFilterData();
    formData.filter = filter;
    formData.offset = offset;
    this.showOrHideTableColumns();
    await this.getCheckBoxes();
    try {
      this.freshAuthService.getEtb(formData).subscribe(
        (response) => {
          this.noUserFound = '';
          this.allUsers = response && response.resultData ? response.resultData : [];
          this.setCheckBoxesStatuses(this.allUsers);
          if (!this.allUsers.length) {
            this.noUserFound = 'Customer data not found';
          }
          this.totalCount = response && response.count ? response.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          this.loading = false;
        },
        () => {
          this.noUserFound = 'Customer data not found';
          this.loading = false;
          this.totalCount = 0;
          this.totalPage = 0;
        }
      );
    } catch (error) {
      this.snackbar.open(error.message, 'OK', {
        duration: 4000,
      });
      this.loading = false;
      this.totalCount = 0;
      this.totalPage = 0;
    }
  }

  showOrHideTableColumns() {
    // debugger
    if (constants.STATES.OD.POSSIBILITIES.includes(sessionStorage.getItem('stateCode').toLowerCase()) ||
    constants.STATES.TN.POSSIBILITIES.includes(sessionStorage.getItem('stateCode').toLowerCase()) ||
    constants.STATES.AD.POSSIBILITIES.includes(sessionStorage.getItem('stateCode').toLowerCase())
  ) {
      this.showChecksColumn = true;
      this.showDownloadUploadColumn = true;
      this.showSanctionedDocuments = true;
    } else {
      this.showChecksColumn = false;
      this.showDownloadUploadColumn = false;
    }
  }
}
